
import XButton from 'vux/src/components/x-button/index.vue'
import Flexbox from 'vux/src/components/flexbox/flexbox.vue'
import FlexboxItem from 'vux/src/components/flexbox/flexbox-item.vue'

export default {
name: 'sign-files',
components: {
XButton,
Flexbox,
FlexboxItem
},
created () {
this.projectId = this.$route.query.projectId;
this.openId = window.sessionStorage.getItem("openId");
this.taskType = this.$route.query.taskType;
this.productCode = this.$route.query.productCode;
this.currentkey = this.$route.query.currentkey;

if (this.currentkey == 'task') {

window.sessionStorage.setItem("currentkey", "1")
} else {

window.sessionStorage.setItem("currentkey", "3")
}


if (this.projectId == '' || this.projectId === null || this.projectId == undefined ) {
this.$vux.toast.text("projectId为null");
} else if (this.openId == undefined || this.openId == '') {
this.$vux.toast.text("openId为null");
} else {
this.getVersion()
this.getFilesList(this.projectId, this.openId);

}

document.body.addEventListener('focusout', function () {
window.scrollTo(0,0);
});
},
data: function () {
return {
base64file: '',
perType: '',
projectId: '',
openId: '',
version:null,
filelist: [

],
status: "2",
taskType: '',
productCode: '',
currentkey: '',
}
},
methods: {

getFilesList(projectId, openId) {
const url = "/wechat/getSignFileList.do";
const thiss = this;
this.$axios({
method: 'post',
url: url,
data: {
openId: openId,
projectId: projectId,
}
}).then((response) => {
if (response.data.code === 200) {

thiss.filelist = response.data.result.fileList;
thiss.handleFileName(thiss.filelist);
thiss.status = response.data.result.status + '';

} else {

}
}).catch(function(err){

});
},

getVersion(){
const url = "/wechat/getVersion.do";
var thiss=this
this.$axios({
method: 'post',
url: url,
}).then((response) => {
if (response.data.code === 200) {
thiss.version=response.data.result.version
} else {

}
}).catch(function(err){

});
},

seeFile (value) {
var url =null
if(this.version==='1'){
url = "/wechat/contractPreview.do";
}
if(this.version==='0'){
url = "/wechat/getContactById.do";
}
const thiss = this;
this.$axios({
method: 'get',
url: url,
params: {
contractId: value.contractId,
}
}).then((response) => {
if (response.data.code === 200) {
let result = null
if(thiss.version==='0'){
result = "data:" + value.fileType + ';base64,' + response.data.result;
thiss.$router.push({path: '/filespdf', query: {
title: value.srcFileName
}});
}
if(thiss.version==='1'){
result =response.data.result.trim()
location.href=result
}

sessionStorage.setItem("eachfile",result);


} else {

}
}).catch(function(err){

});

},

onCancel () {
const currentkey = this.$route.query.currentkey;
if (currentkey != '' && currentkey != null && currentkey != undefined) {
this.$router.back(-1);
} else {
WeixinJSBridge.call('closeWindow');
}

},


confirmSign () {
const $this = this;
const url = "/wechat/validCode.do";
this.$axios({
method: "post",
url: url,
data: {
verifyCode: '',
projectId: this.projectId,
openId: this.openId,
taskType: this.taskType,
}
}).then((response) => {
if (response.data.code === 200) {
const {erCode, verifycode, bucket, key, token, operate, url: uploadUrl} = response.data.result;
if (erCode == 0) {
if (operate == 1 || operate == 0) {
$this.$router.push({
name: 'faceRecognition',
query: {projectId: this.projectId, productCode: this.productCode, taskType: this.taskType}
});
} else if (operate == 2 || operate == 3) {
window.sessionStorage.setItem("pagePositioning", "pagePositioning");
if (operate == 2) {
localStorage.setItem('uploadUrl', uploadUrl);
}
$this.$router.push({
name: 'livefaceRecognition',
query: {projectId: this.projectId, productCode: this.productCode, taskType: this.taskType, verifycode, bucket, key, token, operate}
});
} else {
this.$vux.toast.text(response.data.result.erMsg);
}
} else {
this.$vux.toast.text(response.data.result.erMsg);
}
} else {
this.$vux.toast.text(response.data.message);
}
}).catch(function(err){

});
},

handleFileName (list) {
if (list == null || list.length == 0) {
return ;
}
const thiss = this;
list.forEach(function (item, index) {

item.srcFileName = thiss.checkFileName(item.srcFileName);
});
},
checkFileName (filename) {
if (filename == '' || filename == undefined) {
return '';
}
let length = filename.indexOf('.pdf');
return filename.substring(0, length);
},
}
}



// WEBPACK FOOTER //
// ./src/pages/SignFiles.vue